import config from "../../../config"
export const downloadMonumentAppQuery = `{
    downloadMonumentApp(id: "${process.env.REACT_APP_DOWNLOAD_APP_ID}") {
        title
        summary
        qr {
            fileName
            url 
          }
          logo{
            fileName
            url
          }
          qrSummary
          appStore {
            fileName
            url
          }
          playStore {
            fileName
            url
          }
    }
  }`
/*
 parse the input data if undefined add error message.
 On success condition, structure code for Download app component.
 */
export function parseDownloadAppData(CMSData) {
  if (CMSData == undefined) {
    return { error: `${config.downloadAppConst.errorpageMsg}` }
  } else {
    return {
      ...CMSData.downloadMonumentApp,
    }
  }
}
